import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	padding: 20px 20px 0;

	transition: opacity 0.3s ease;

	&.page-enter {
		opacity: 0;
	}

	&.page-enter-active,
	&.page-enter-done,
	&.page-exit {
		opacity: 1;
	}

	&.page-exit-active {
		opacity: 0;
	}
`;

const StyledHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledHeadItemsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledHeadTitleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	height: 40px;
	padding: 0 10px;
	border-radius: 10px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledHeadButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledFiltersContainer = styled.div`
	display: grid;
	grid-template-columns: 240px 240px;
	gap: 10px;
`;

const StyledCreateButton = styled(StyledHeadButton)`
	background-color: #2d70da;
`;

const StyledFavoriteButton = styled(StyledHeadButton)`
	background-color: #c71e1e;
`;

const StyledItemsGrid = styled.div`
	display: grid;
	height: 549px;
	margin-top: 20px;
	padding-bottom: 20px;
	overflow-y: scroll;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px;
	transition: opacity 0.3s ease;

	&.grid-enter {
		opacity: 0;
	}

	&.grid-enter-active,
	&.grid-enter-done,
	&.grid-exit {
		opacity: 1;
	}

	&.grid-exit-active {
		opacity: 0;
	}

	&::-webkit-scrollbar {
		display: none;
	}
`;

export {
	StyledContainer,
	StyledCreateButton,
	StyledFavoriteButton,
	StyledFiltersContainer,
	StyledHead,
	StyledHeadItemsContainer,
	StyledHeadTitleContainer,
	StyledItemsGrid,
};
